'use client';
import clsx from 'clsx';
import { HTMLMotionProps, motion } from 'framer-motion';
import React from 'react';

import S from './BaseButton.module.scss';

import useHovered from 'hooks/useHovered';

export interface BaseButtonProps
  extends Omit<HTMLMotionProps<'button'>, 'type'> {
  className?: string;
}

const BaseButton: React.FC<BaseButtonProps> = ({
  children,
  className,
  ...rest
}) => {
  const [hovered, setHovered] = useHovered();

  return (
    <motion.button
      onMouseEnter={() => setHovered(true)}
      onTouchStart={() => setHovered(true)}
      onMouseLeave={() => setHovered(false)}
      onFocus={() => setHovered(true)}
      onBlur={() => setHovered(false)}
      className={clsx(S.BaseButton, className, hovered && S.Hovered)}
      {...rest}
    >
      {children}
    </motion.button>
  );
};

export default BaseButton;
